// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"441174fb","667":"f0b5d063"}[chunkId] + ".chunk.js";
};